import { render, staticRenderFns } from "./ModalAvenant.vue?vue&type=template&id=f61f3fb8&scoped=true&"
import script from "./ModalAvenant.vue?vue&type=script&lang=js&"
export * from "./ModalAvenant.vue?vue&type=script&lang=js&"
import style0 from "./ModalAvenant.vue?vue&type=style&index=0&id=f61f3fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61f3fb8",
  null
  
)

export default component.exports